import { MenuItem, MenuRadioGroup, SubMenu } from '@szhsin/react-menu';

import React from 'react';
import { SettingsContext } from '../../../context/context';
import { useContext } from 'react';

const PaperSize = () => {
  const { state, dispatch } = useContext(SettingsContext);
  return (<SubMenu label="Paper">
    <MenuRadioGroup value={state.paperSize}
        onRadioChange={e => dispatch({ type: 'paperSize', payload: e.value})}>
        <MenuItem type="radio" value="A3">A3</MenuItem>
        <MenuItem type="radio" value="A4">A4</MenuItem>
        <MenuItem type="radio" value="A5">A5</MenuItem>
        <MenuItem type="radio" value="letter">Letter</MenuItem>
        <MenuItem type="radio" value="legal">Legal</MenuItem>
    </MenuRadioGroup>
    </SubMenu>);
};

export default PaperSize;
